import type { ReactNode } from "react";

import { Stack } from "@/design-system/Stack";

interface ResponsiveCollectionProps {
  controls?: ReactNode;
  wide: ReactNode;
  compact: ReactNode;
}

/** Owns the ticket-collection query boundary and switches between wide and compact representations. */
export function ResponsiveCollection({ compact, controls, wide }: ResponsiveCollectionProps): ReactNode {
  return (
    <div className="@container min-w-0 flex-1">
      <Stack gap="sm">
        {controls}
        <div className="hidden w-full @sm:block">{wide}</div>
        <div className="w-full pb-space-sm @sm:hidden">{compact}</div>
      </Stack>
    </div>
  );
}
